import React from 'react';
import { clsx } from 'clsx';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  noPadding?: boolean;
}
export function Card({
  className,
  noPadding = false,
  children,
  ...props
}: CardProps) {
  return <div className={clsx('bg-white rounded-lg border border-[#E5E5E5] shadow-sm', !noPadding && 'p-5', className)} {...props} data-id="element-332">
      {children}
    </div>;
}
interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  bordered?: boolean;
}
export function CardHeader({
  className,
  bordered = false,
  children,
  ...props
}: CardHeaderProps) {
  return <div className={clsx('flex items-center justify-between', bordered ? 'px-5 py-4 -mx-5 -mt-5 mb-5 border-b border-[#E5E5E5] bg-[#FAFAFA]' : 'mb-5', className)} {...props} data-id="element-333">
      {children}
    </div>;
}
export function CardTitle({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={clsx('text-base font-semibold text-[#181818]', className)} {...props} data-id="element-334">
      {children}
    </h3>;
}